import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"
import { Collapse } from "bootstrap"

export default class extends Controller {
  static values = { url: String }

  initialize() {
    this.timeout = null;
  }

  connect() {
    this.element.addEventListener('tinymce:change', () => this.updatePreview());
    this.element.addEventListener('keyup', () => this.updatePreview());
    this.element.addEventListener('change', () => this.updatePreview());
  }

  updatePreview() {
    if (this.timeout) {
      return;
    }

    this.timeout = setTimeout(async () => {
      const formData = new FormData(this.element);
      this.fetch(formData);
      this.timeout = null;
    }, 400);
  }

  fetch(formData) {
    // avoid uploading potentially very big files
    const header_media = formData.get("whatsapp_message[header_media]");
    formData.delete("whatsapp_message[header_media]");

    formData.set("_method", "post")

    // Still allow a preview on pictures.
    if (header_media && (header_media.type == "image/png" || header_media.type == "image/jpeg" || header_media.type == "image/jpg")) {
      window.addEventListener("turbo:before-stream-render", (event) => {
        // FIXME: this is more a hack than a solution, but it works for now, the render
        //        on the event should be used instead, but I don't know how this works
        //
        // WARNING: the issue with this setup is, that a smaller image replacing a bigger image, or an image
        //          replacing another placeholder like for videos is flickering on each character input
        // 
        // event.detail.render = (currentElement, newElement) => {
        //   console.log(currentElement, newElement);
        // };
        setTimeout(() => {
          const reader = new FileReader();
          const preview = document.getElementById("app_img_preview_placeholder");

          if (!preview) {
            return;
          }

          reader.addEventListener("load", () => {
            const img = document.createElement("img");
            img.src = reader.result;
            preview.replaceWith(img);
          }, false);

          reader.readAsDataURL(header_media);
        }, 100);
      }, { once: true });
    }

    post(this.urlValue, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: formData
    })
  }

  loadPreview(event) {
    const previewContainer = document.getElementById("moveable-app-preview");
    const collapse = new Collapse(previewContainer, {
      toggle: false
    });
    const messageId = this.element.dataset.itemId

    if (previewContainer.dataset.messageId != messageId) {
        const formData = new FormData();
        formData.append('whatsapp_message[whatsapp_message_id]', messageId);
        formData.append('img_preview', true);
        this.fetch(formData);

        previewContainer.dataset.messageId = messageId;
        collapse.show();
        return;
    }

    previewContainer.dataset.messageId = "";
    collapse.hide();
  }
}
